import {EventAirportPost} from "../../types/domain.ts";
import {baseRequestService} from "../base.ts";

export const eventsEventIdAirportsPost = (eventId: string, data: EventAirportPost) => baseRequestService({
    url: `/events/${eventId}/airports`,
    method: 'POST',
    data
})